import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Clock, TrendingDown } from 'lucide-react';
const benefits = [{
  icon: Clock,
  title: 'Швидкість роботи',
  description: 'Ідентифікатор протягом 1 години. Відправка готового Звіту про оцінку того ж дня Новою поштою.'
}, {
  icon: TrendingDown,
  title: 'Мінімізація податків',
  description: 'Робимо оціночну вартість на 25% нижче е-Довідки. Можлива занижена оцінка в рамках закону.'
}, {
  icon: ShieldCheck,
  title: 'Повна законність',
  description: "100% дотримання законодавства. Обов'язкове внесення Звіту до Єдиної бази звітів ФДМУ."
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function Benefits() {
  return <section className="py-24 md:py-32 bg-gray-50 px-6" data-id="element-28">
      <div className="max-w-7xl mx-auto" data-id="element-29">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-30">
          {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className="flex flex-col items-start" data-id="element-31">
              <div className="w-12 h-12 rounded-2xl bg-white shadow-sm flex items-center justify-center mb-6 border border-gray-100" data-id="element-32">
                <benefit.icon className="text-gray-900" size={24} strokeWidth={1.5} data-id="element-33" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-34">
                {benefit.title}
              </h3>
              <p className="text-gray-500 leading-relaxed font-light" data-id="element-35">
                {benefit.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}